"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CheckboxGroup = _interopRequireDefault(require("./CheckboxGroup.vue"));
var _default = exports.default = _CheckboxGroup.default;